const rentGptApi = process.env.GATSBY_RENT_GPT_API_URL;
const rentScriptApi = process.env.GATSBY_RENT_GPT_SCRIPTS_URL;

export const GOOGLE_MAPS_API_KEY = process.env.GATSBY_GOOGLE_MAPS_API_KEY;

export const api = {
  async get(path, options = {}) {
    let url = `${rentGptApi}${path}`;
    if (options.params) {
      url += `?${new URLSearchParams(options.params).toString()}`;
    }
    const res = await fetch(url, {
      headers: { 'Content-Type': 'application/json', ...options.headers },
    });
    const data = await res.json();
    return { data };
  },

  async post(path, body, options = {}) {
    const res = await fetch(`${rentGptApi}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options.headers },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    return { data };
  },
};

export const bindChatFiles = () => {
  const hasScript = document.getElementById('rent-gpt-script');
  if (hasScript) return;
  const script = document.createElement('script');
  script.id = 'rent-gpt-script';
  script.src = `${rentScriptApi}/widget.js`;
  script.async = true;
  document.body.appendChild(script);
  const styles = document.createElement('link');
  styles.rel = 'stylesheet';
  styles.href = `${rentScriptApi}/widget.css`;
  document.body.appendChild(styles);
  const o = '_ChatWidget';
  window.RGptWidget = o;
  window[o] =
    window[o] ||
    // eslint-disable-next-line func-names
    function () {
      // eslint-disable-next-line prefer-rest-params
      window[o].q = [arguments];
    };
  // eslint-disable-next-line no-undef
  _ChatWidget('init', {
    position: 'right',
  });
};

export function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}
